import {Route} from 'react-router'
import LoggedRoute from '@freckle/school/ts/common/routers/logged-route'
import {ErrorPage} from '@freckle/school/ts/pages/error-page'

export default function RouterV2Error() {
  return (
    <>
      <Route path="/error" element={<LoggedRoute component={ErrorPage} />} />
    </>
  )
}
